module.exports = __webpack_public_path__ + "img/dots_bg3.83027661.svg";